import React from "react";
import FlatList from "flatlist-react";
import { formatDateH } from "../../../helpers/helpersFunction";
import { DeleteSolicitudButton } from "./DeleteSolicitudButton";
import { ResendSolicitudButton } from "./ResendSolicitudButton";


const TablaSolicitudes = ({ setSolicitudes, solicitudes , resultado }) => {

  if (!solicitudes.length) {
    return (
      <div className="renderEmpty">
        {resultado === "0" ? <p>Información no disponible</p> : <p style={{fontSize:'1.9rem'}} ></p>}
      </div>
    );
  }



  return (
    <div className="contenidoTodoTablaVacaciones">
      <div className="headerTablaVacaciones">
        <p>Desde</p>
        <p>Hasta</p>
        <p>Hábiles</p>
        <p>Estado</p>
        {/* <p>Fecha Sol.</p> */}
        <p>Correo</p>

        <p>Acción</p>

      </div>

      <div className="contenidoTablaVacacionesSolicitud">
        <FlatList
          list={solicitudes}
          renderItem={(item, index) => (
            <div key={index} className="divflat">
              <p>{formatDateH(item.desde)}</p>
              <p>{formatDateH(item.hasta)}</p>
              <p>{item.diash}</p>
              <p>{item.estado}</p>
              {/* <p>{formatDateH(item.fsol)}</p> */}
              <p style={{fontSize:'1.45rem'}} >{item.encargado}</p>


              {
                item.estado === 'P' &&
                // <div>
                <div style={{width:'20%', display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'center', gap:'1.5rem'}} >

                  
                  <DeleteSolicitudButton  setSolicitudes={setSolicitudes} solicitudes={solicitudes} id={item.id} /> 
                  <ResendSolicitudButton  id={item.id} /> 

                </div> 
                 
            
              
              }
              {
               ( item.estado === 'A' || item.estado === 'R') &&  <p>-</p>
              }

           


            </div>
          )}
        />
      </div>
    </div>
  );
};

export default TablaSolicitudes;
